// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"216":"33d9c724","425":"23b42056"}[chunkId] + ".css";
};